import { render, staticRenderFns } from "./BaseSpeechInput.vue?vue&type=template&id=3ac39819&"
import script from "./BaseSpeechInput.vue?vue&type=script&lang=js&"
export * from "./BaseSpeechInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports